import { CommonResponse, SuccessResponse, ErrorResponse } from 'src/types';

export const isSuccessResponse = <T>(response: CommonResponse<T>): response is SuccessResponse<T> =>
  !(response as ErrorResponse)?.message;

export const isErrorResponse = <T>(response: CommonResponse<T>): response is ErrorResponse =>
  (response as ErrorResponse)?.message !== undefined;
